import { sectionsOnStageSelectors } from './sectionsOnStage.selectors';
import { sectionsOnStageReducer } from './sectionsOnStage.reducer';
import { sectionsOnStageActions } from './sectionsOnStage.actions';

export const sectionsOnStage = {
  actions: sectionsOnStageActions,
  reducer: sectionsOnStageReducer,
  selectors: sectionsOnStageSelectors,
};
